import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import Driver from '~/assets/drivers.jpg';
import AppToolBar from '~/components/AppToolBar';
import { DriverFaq, DriverForm, DriverTestimonials, WhyDriveWithUs } from '~/components/drivers';
import ImageBox from '~/components/ImageBox.jsx';
import Page from '~/components/Page.jsx';

const useStyles = makeStyles((theme) => ({
  drivers: {
    marginBottom: 60,
  },
  primary: {
    color: theme.palette.primary.main,
  },
  heroContainer: {
    width: '100%',
    position: 'relative',
    textAlign: 'center',
    lineHeight: 0,
  },
  heroText: {
    position: 'absolute',
    left: '50%',
    bottom: '50px',
    transform: 'translate(-50%,0)',
    width: '60%',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      width: '75%',
    },
    '& h1, & h3': {
      fontFamily: 'proximanova-bold',
      color: 'white',
    },
    '& h1': {
      fontSize: 'max(24px,5vw)',
    },
    '& h3': {
      fontSize: 'max(25px,2.3vw)',
    },
  },
  driverImage: {
    [theme.breakpoints.up('md')]: {
      height: 600,
    },
    width: '100%',
    overflow: 'hidden',
  },
  section: {
    paddingTop: 88,
    paddingBottom: 88,
  },
}));

const Drivers = () => {
  const classes = useStyles();
  return (
    <Page name='drivers' fullWidth>
      <AppToolBar variant='secondary' />
      <Grid container justify='center' className={classes.drivers}>
        <div className={classes.heroContainer}>
          <div className={classes.heroText}>
            <Typography variant='h1'>Deliver with Chowbus</Typography>
            <Typography variant='h3'>
              Flexible schedule. Instant deposits. Be your own boss.
            </Typography>
          </div>
          <div className={classes.driverImage}>
            <ImageBox src={Driver} fit='cover' style={{ objectPosition: '50% 0' }} />
          </div>
        </div>
        <Grid item xs={12} className={classes.section}>
          <DriverForm />
        </Grid>
        <Grid item xs={12}>
          <WhyDriveWithUs />
        </Grid>
        <Grid item xs={12}>
          <DriverTestimonials />
        </Grid>
        <Grid item sm={8} xs={10} className={classes.section}>
          <DriverFaq />
        </Grid>
      </Grid>
    </Page>
  );
};

export default Drivers;

export async function getStaticProps() {
  return {
    props: {},
  };
}
